import { useEffect, useRef, useState } from "react";

import { Tooltip } from "@similarweb/ui-components";
import { Text } from "@similarweb/ui-components/foundations";

const TruncatedTitle = ({
    ref,
    children,
}: {
    ref: React.RefObject<HTMLSpanElement | null>;
    children: React.ReactNode;
}) => (
    <Text
        ref={ref}
        width="100%"
        display="inline-block"
        fontVariant="subtitle2"
        whiteSpace="nowrap"
        overflow="hidden"
        textOverflow="ellipsis"
        textTransform="capitalize"
        data-automation="card-title"
    >
        {children}
    </Text>
);

interface TopicsDiscoverTrendCardTitleProps {
    name: string;
}

export const TopicsDiscoverTrendCardTitle = ({ name }: TopicsDiscoverTrendCardTitleProps) => {
    const titleRef = useRef<HTMLSpanElement>(null);
    const [hasOverflow, setHasOverflow] = useState(false);

    useEffect(() => {
        const checkOverflow = () => {
            if (titleRef.current) {
                setHasOverflow(titleRef.current.scrollWidth > titleRef.current.clientWidth);
            }
        };

        checkOverflow();
        window.addEventListener("resize", checkOverflow);

        return () => {
            window.removeEventListener("resize", checkOverflow);
        };
    }, []);

    if (hasOverflow) {
        return (
            <Tooltip content={name}>
                <span>
                    <TruncatedTitle ref={titleRef}>{name}</TruncatedTitle>
                </span>
            </Tooltip>
        );
    }

    return <TruncatedTitle ref={titleRef}>{name}</TruncatedTitle>;
};
